export default "__VITE_ASSET__Bq5687FT__"